var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0694 12.883C13.3615 12.2967 12.5218 11.6069 11.7531 11.0751C12.3749 10.302 12.7486 9.32174 12.7486 8.25517C12.7486 5.7703 10.7302 3.75 8.24932 3.75C5.76843 3.75 3.75 5.7703 3.75 8.25517C3.75 10.7391 5.76843 12.7608 8.24932 12.7608C9.30605 12.7608 10.2761 12.3919 11.0452 11.7792C11.5738 12.5469 12.2597 13.3849 12.8456 14.0938C13.4664 14.8336 14.1409 15.5651 14.796 16.25L16.25 14.865C15.57 14.213 14.7974 13.4962 14.0694 12.883ZM4.99682 8.25516C4.99682 6.45957 6.45577 4.99757 8.24932 4.99757C10.0434 4.99757 11.5018 6.45957 11.5018 8.25516C11.5018 10.0508 10.0434 11.5118 8.24932 11.5118C6.45577 11.5118 4.99682 10.0508 4.99682 8.25516Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Search.e02bd9daf1fd98668c7835acf32bd3a5.svg";